type Props = {
  color: string;
  height?: string;
  width?: string;
};

const ProfileIcon = ({ color, height = '24', width = '24' }: Props) => {
  return (
    // <svg
    //   width="16"
    //   height="17"
    //   viewBox="0 0 16 17"
    //   xmlns="http://www.w3.org/2000/svg"
    //   id="login"
    //   fill="#56BD6F"
    // >
    //   <g id="HEADER" transform="translate(-283.000000, -30.000000)">
    //     <g>
    //       <g
    //         id="Icon_x2F_Nav_x2F_Profile_x2F_Active"
    //         transform="translate(279.000000, 26.000000)"
    //       >
    //         <g id="profile">
    //           <g id="head">
    //             <path
    //               fill={color}
    //               d="M12,12c-2.206,0-4-1.794-4-4s1.794-4,4-4c2.206,0,4,1.794,4,4S14.206,12,12,12z M12,6 c-1.103,0-2,0.897-2,2s0.897,2,2,2c1.103,0,2-0.897,2-2S13.103,6,12,6z"
    //             ></path>
    //           </g>
    //           <g id="bust">
    //             <path
    //               fill={color}
    //               d="M20,21H4v-1c0-3.859,3.14-7,7-7h2c3.859,0,7,3.141,7,7V21z M6.101,19h11.799 c-0.465-2.279-2.484-4-4.899-4h-2C8.585,15,6.565,16.721,6.101,19z"
    //             ></path>
    //           </g>
    //         </g>
    //       </g>
    //     </g>
    //   </g>
    // </svg>
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 20C20 18.1435 19.1571 16.363 17.6569 15.0503C16.1566 13.7375 14.1217 13 12 13C9.87827 13 7.84344 13.7375 6.34315 15.0503C4.84286 16.363 4 18.1435 4 20L20 20Z"
        stroke={color}
        strokeWidth="2"
      />
      <circle cx="12" cy="7" r="3" stroke={color} strokeWidth="2" />
    </svg>
  );
};

export default ProfileIcon;
